import React from 'react';
import { Link } from 'react-router-dom';
import FontAwesome from '../common/FontAwesome';
import './recipe.scss';

function RecipeContent(props) {
  const siteConfig = props.page;
  const recipeStyles = 'recipe-content-page default';
  const recipeBlock = siteConfig.components.find(
    (component) => component.block_type === 'RecipeBlock'
  );

  if (!recipeBlock || !recipeBlock.recipes || recipeBlock.recipes.length === 0) {
    return null;
  }

  const recipeSectionTitleColor = recipeBlock.recipe_section_title_color;
  const recipeCardBackgroundColor = recipeBlock.recipe_card_background_color;
  const recipeCardTextColor = recipeBlock.recipe_card_text_color;
  const recipeViewButtonBackgroundColor = recipeBlock.recipe_view_button_background_color;
  const recipeViewButtonTextColor = recipeBlock.recipe_view_button_text_color;
  const recipeButtonA2CTextColor = recipeBlock.recipe_button_a2c_text_color;
  const recipeButtonA2CBackgroundColor = recipeBlock.recipe_button_a2c_background_color;

  function RecipeItem({ recipe }) {
    const {
      title,
      card_text,
      card_image,
      a2c,
      slug,
      recipe_detail_show_time_headers,
    } = recipe;

    function trackAddToCartEvent() {
      window.gtag('event', 'addtocartclick', {
        product: title,
        version: localStorage.getItem("AB_TEST_VARIABLE") || 'N/A'
      });
    }

    function trackGetRecipe() {
      window.gtag('event', 'viewrecipe', {
        recipe: title,
        version: localStorage.getItem("AB_TEST_VARIABLE") || 'N/A'
      });
    }

    let recipe_basepath = process.env.REACT_APP_PREVIEW_MODE === 'true' 
      ? window.location.href 
      : window.location.href.replace(/\/$/, '');
  
    // if (process.env.REACT_APP_PREVIEW_MODE === 'true') {
    //   recipe_basepath = `/${siteConfig.siteName}`;
    // } else {
    //   recipe_basepath = '';
    // }

    return (
      <div className="recipe-item" style={{ backgroundColor: recipeCardBackgroundColor }}>
        <div className='imageContent'>
          <img src={card_image} className="card-img-top content-img" alt={title} />
          {a2c && (
            <a
              href={a2c}
              onClick={trackAddToCartEvent}
              target="_blank"
              rel="noopener noreferrer"
              className='cart'
              style={{ color: recipeCardTextColor }}
            >
              <FontAwesome type='shopping-cart' />
            </a>
          )}
        </div>
        <div className='textContent' style={{ color: recipeCardTextColor }}>
          <div className='button-items'>
            <Link 
              style={{ 
                backgroundColor: recipeViewButtonBackgroundColor, 
                color: recipeViewButtonTextColor,
                fontSize: '14px',
                fontWeight: '700',
                display: 'flex',
                padding: '16px 48px',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '16px',
                borderRadius: '240px',
                boxShadow: '0px 2px 4px rgba(107, 114, 128, 0.12), 0px 3px 5px rgba(107, 114, 128, 0.15)',
                textDecoration: 'none',
              }}
              to={`${recipe_basepath}/recipes/${slug}`}
              onClick={() => {
                trackGetRecipe();
                setTimeout(() => {
                  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
                }, 0);
              }}
            >
              View Recipe
            </Link>
            {a2c && (
              <button className="item-btn cart-btn" style={{ backgroundColor: recipeButtonA2CBackgroundColor }}>
                <a
                  href={a2c}
                  onClick={trackAddToCartEvent}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: recipeButtonA2CTextColor }}
                >
                  Add to Cart
                </a>
              </button>
            )}
          </div>
          <div className='text-block'>
            <h4>{title}</h4>
            <p>{card_text}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='recipe-container'>
      <div className={recipeStyles} id="recipesection">
        <div className="tw-w-full tw-max-w-[1440px] tw-mx-auto tw-px-4 tw-py-8 tw-flex tw-flex-col tw-justify-start tw-items-center tw-gap-4">
          <div className="tw-text-center tw-text-zinc-800 tw-text-4xl tw-font-extrabold tw-font-['Switzer Variable'] tw-leading-tight sm:tw-text-5xl md:tw-text-6xl lg:tw-text-7xl" style={{ textAlign: 'center', marginLeft: 0, color: recipeSectionTitleColor }}>{recipeBlock.section_title ? <p>{recipeBlock.section_title}</p> : <p>Recipe</p>} </div>
          <div className="tw-w-full tw-max-w-[680px] tw-text-center tw-text-zinc-800 tw-text-base tw-font-normal tw-font-['Switzer Variable'] tw-leading-snug sm:tw-text-lg md:tw-text-xl"  style={{ textAlign: 'center', color: recipeSectionTitleColor }}>{recipeBlock.section_subheader}</div>
        </div>
        <div className='recipeArea'>
          <div className="recipe-content">
            <div className="recipe-section">
              <div className='recipeBlock'>
                {recipeBlock.recipes.map((recipe, j) => (
                  <RecipeItem recipe={recipe} key={j} />
                ))}
              </div>
            </div>
            <div className='clearer'></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecipeContent;
